import { Routes } from '@angular/router';
import {WelcomeComponent} from "./pages/welcome/welcome.component";
import {firstLaunchGuard} from "./shared/guard/first-launch.guard";

export const routes: Routes = [
  {
    path: 'welcome',
    loadComponent: () => import('./pages/welcome/welcome.component').then(c => c.WelcomeComponent),
    //canActivate: [firstLaunchGuard],
  },
  {
    path: 'app',
    loadChildren: () => import('./tabs/tabs.routes').then((m) => m.routes),
  },
  {
    path: '',
    redirectTo: 'welcome',
    pathMatch: 'full'
  }
];
